import axios from '../../plugins/axios'
import fileDownload from 'js-file-download'
import moment from 'moment-timezone'

export const listDelivery = ({ commit }, { params } = {}) => {
  return axios.get('/delivery', { params })
    .then(response => {
      commit('SET_DELIVERIES', response.data.rows)
      commit('SET_COUNT_STATUS', response.data.countStatus)
      return response
    })
    .catch(err => err.response)
}

export const countPartnerErrorDeliveries = ({ commit }, { params } = {}) => {
  return axios.get('/delivery/count-partner-error-deliveries', { params, })
    .then(response => {
      commit('SET_PARTNER_ERROR_COUNT', response.data.count)
      return response
    })
}

export const exportPickupPreLiquidation = (_, { params } = {}) => {
  return axios.get('/delivery/export-pickup-pre-liquidation', { params, responseType: 'blob' })
    .then(response => {
      fileDownload(response.data, response.headers['content-disposition'].split('filename=')[1])
      return response
    })
}
export const downloadExcelDelivery = (_, { params } = {}) => {
  return axios.get('/delivery-excel', { params, responseType: 'blob' })
    .then(response => {
      const format = (date) => {
        return moment(date).format('DD-MM-YYYY')
      }
      const date = params.startDate
        ? format(params.startDate) + '_al_' + format(params.endDate)
        : format(params.date)

      fileDownload(response.data, response.headers['content-disposition'].split('filename=')[1])

      return response
    })
}

export const deleteDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.delete(`/delivery/${payload.id}`, config)
    .then(response => response)
    .catch(err => err.response)
}

export const deleteMultipleDeliveries = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.delete('/deliveries', { data: payload, ...config })
    .then(response => response)
    .catch(err => err.response)
}

export const updateDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put(`/delivery/${payload.id}`, payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const bulkCreateDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/bulk_delivery', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const getMyDeliveries = (_) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.get('/my-delivery', config)
    .then(response => response)
    .catch(err => err.response)
}

export const getDriverDeliveryById = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.get(`/driver-delivery/${payload.id}`, config)
    .then(response => response)
    .catch(err => err.response)
}

export const listDeliveriesByDateAndStatus = (_, { params } = {}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` }, params }
  return axios.get('/my-delivery-with-data', config)
    .then(response => response.data)
    .catch(err => err.response)
}

export const generatePDF = (_, payload) => {
  return axios.post('/generate-pdf', payload)
    .then(response => response)
    .catch(err => err.response)
}

export const completeDelivery = (_, { data, deliveryId }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
  return axios.put(`/complete-delivery/${deliveryId}`, data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const deliveryTracking = (_, payload) => {
  return axios.post('/delivery-tracking', payload)
    .then(response => response)
    .catch(err => err.response)
}


export const getDeliveryScanned = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post(`/delivery/scan`, payload, config)
}

export const bulkSetPartner = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/delivery/bulk-set-partner', payload, config)
}

export const getDeliveryByLabelCode = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/delivery/get-by-label-code', payload, config)
}

export const getManagementControlStats = (_, { params } = {}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` }, params }
  return axios.get('/delivery/management-control-stats', config)
    .then(response => response.data)
    .catch(err => { throw err })
}

// Solo la respuesta de la última consulta actualiza los contadores, para que una
// respuesta lenta de un filtro anterior no pise la del filtro vigente
let countersRequestId = 0

export const getCountersForDriver = ({ commit }, { params } = {}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` }, params }
  const requestId = ++countersRequestId
  return axios.get('/delivery/counters-for-driver', config)
    .then(response => {
      if (requestId === countersRequestId) {
        commit('SET_DRIVER_DELIVERY_COUNTERS', response.data)
      }
      return response.data
    })
    .catch(err => { throw err })
}

export const bulkTriggerWebhook = (_, payload) => {
  return axios.post('/delivery/bulk-trigger-webhook', payload)
    .then(response => response)
    .catch(err => { throw err })
}

export const bulkSyncPartner = (_, payload) => {
  return axios.post('/delivery/bulk-sync-partner', payload)
    .then(response => response)
    .catch(err => { throw err })
}

export const bulkSetStatus = (_, payload) => {
  return axios.post('/delivery/bulk-set-status', payload)
    .then(response => response)
    .catch(err => { throw err })
}